/** */
import { urls } from '../_url';
import { apiGet, apiPost } from '../_http';

/** */
const base_url = `${urls.sales}/invoices`;

export const read = async (options = {}) => {
  return await apiGet(base_url, { ...options });
};

export const generateInvoice = async (options = {}) => {
  return await apiPost(`${base_url}/agency/generate`, { ...options });
};
